import React from 'react';
import {Switch} from 'antd'

const SwitchCustom = ({...rest}) => (
            <div className="switch-custom">
                <Switch {...rest}/>
            </div>
);

export default SwitchCustom;